import type { ReactNode } from 'react'
import s from './Callout.module.scss'

export type CalloutTone = 'neutral' | 'note'

/**
 * Ein abgesetzter Absatz mit linkem Balken.
 *
 * Für Text, der neben dem Sachverhalt steht und nicht in ihm: die Einschätzung
 * eines Menschen, ein Merkposten für den nächsten Fall. Der Balken macht
 * sichtbar, dass hier jemand spricht — in einem gemeinsamen Absatz ließe sich
 * später nicht mehr trennen, was belegt war und was jemand gemeint hat.
 */
export function Callout({ title, tone = 'neutral', children }: {
  title?: string
  tone?: CalloutTone
  children: ReactNode
}) {
  return (
    <p className={s.callout} data-tone={tone}>
      {title && <b className={s.title}>{title} </b>}
      {children}
    </p>
  )
}
